import { render } from "./PaymentReceiptsKpiCard.vue?vue&type=template&id=eff0db1c&scoped=true"
import script from "./PaymentReceiptsKpiCard.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptsKpiCard.vue?vue&type=script&lang=js"

import "./PaymentReceiptsKpiCard.vue?vue&type=style&index=0&id=eff0db1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff0db1c"]])

export default __exports__